import { useEffect, useMemo, useState } from "react";
import styles from "./TopOfferBanner.module.css";
const toMs = (t) =>
  t instanceof Date
    ? t.getTime()
    : typeof t === "string"
    ? new Date(t).getTime()
    : t;
const pad = (n) => String(n).padStart(2, "0");

export default function MobileSaleBanner({
  endTime = "2025-11-30T23:59:59",
  label = "Holiday Week OFF: ",
}) {
  const target = useMemo(() => {
    const ms = toMs(endTime);
    return Number.isFinite(ms) ? ms : 0;
  }, [endTime]);

  const [remaining, setRemaining] = useState(() =>
    Math.max(0, target - Date.now())
  );

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining((prev) => {
        const next = Math.max(0, target - Date.now());
        if (next === 0 && prev === 0) clearInterval(id);
        return next;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [target]);

  const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

  const timeStr = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

  return (
    <div
      className={styles.banner}
      role="status"
      aria-live="polite"
      style={{ fontSize: "13px" }}
    >
      <span className={styles.text}>
        {label}
        <strong>30% OFF</strong>
      </span>

      <span
        className={styles.timerChip}
        aria-label={`Time remaining ${timeStr}`}
      >
        <svg
          className={styles.clock}
          viewBox="0 0 24 24"
          width="16"
          height="16"
          aria-hidden="true"
        >
          <path
            d="M12 8v5l3 1"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="13"
            r="8"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M8 2h8M12 2v3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <span className={styles.time}>{timeStr}</span>
      </span>
    </div>
  );
}
